import Vue from 'vue';

import UsersList from './UsersList.vue';
import UsersQuickActions from './UsersQuickActions.vue';
import UsersInvite from './UsersInvite.vue';

Vue.component('UsersList', UsersList);
Vue.component('UsersQuickActions', UsersQuickActions);
Vue.component('InviteUsers', UsersInvite);
